import { ReduxState } from 'src/store/types';

export const isRefreshingDataSourcesSelector = (state: ReduxState) =>
  state.dataSources.pendingRefreshDataSources;
